import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PermisoDto, ISecPermiso, ISecPermisoAdmin } from '../../shared/interfaces/database/seguridad';

@Injectable({
  providedIn: 'root'
})
export class SecPermisoService {
  private readonly baseUrl = `${environment.apiUrl}/api/permiso`;

  constructor(private http: HttpClient) { }

  getSecPermisoAdmin(): Observable<ISecPermisoAdmin[]> {
    return this.http.get<ISecPermisoAdmin[]>(`${this.baseUrl}`);
  }

  getSecPermisosByTipo(tipo: string): Observable<ISecPermiso[]> {
    return this.http.get<ISecPermiso[]>(`${this.baseUrl}/${tipo}`);
  }

  getSecPermisosByCargoId(cargoId: number): Observable<ISecPermiso[]> {
    return this.http.get<ISecPermiso[]>(`${this.baseUrl}/cargo/${cargoId}`);
  }

  getSecPermisosNoEnCargo(cargoId: number): Observable<ISecPermiso[]> {
    return this.http.get<ISecPermiso[]>(`${this.baseUrl}/no-cargo/${cargoId}`);
  }

  createPermiso(request: PermisoDto): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  updatePermiso(id:number, request: PermisoDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deletePermiso(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }
}
